var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconionicIosMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.743,
    height: 18.913,
    viewBox: "0 0 3.743 18.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-more",
    "data-name": "Icon ionic-ios-more",
    transform: "translate(3.743) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1.872,0A1.872,1.872,0,1,0,3.743,1.872,1.871,1.871,0,0,0,1.872,0Z",
    transform: "translate(7.575 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1.872,0A1.872,1.872,0,1,0,3.743,1.872,1.871,1.871,0,0,0,1.872,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1.872,0A1.872,1.872,0,1,0,3.743,1.872,1.871,1.871,0,0,0,1.872,0Z",
    transform: "translate(15.17 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosMore);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-more.c3cd7055a625622f4661272ae15a05c0.svg";
export { ForwardRef as ReactComponent };